import { Reveal, SectionHeader } from "./Reveal";
import { STEPS } from "../lib/site";

export default function Process() {
    return (
        <section
            id="como-comprar"
            className="bg-cream py-20 sm:py-28 lg:py-32"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <SectionHeader
                    center
                    eyebrow="Como comprar"
                    title={
                        <>
                            Do seu jeito,
                            <br />
                            <span className="italic text-gold-deep">
                                do começo ao fim.
                            </span>
                        </>
                    }
                />

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mt-14 lg:mt-20">
                    {STEPS.map((s, i) => (
                        <Reveal
                            key={s.num}
                            delay={0.08 * i}
                            testId={`process-step-${i + 1}`}
                        >
                            <div className="relative h-full">
                                {i < STEPS.length - 1 && (
                                    <span className="hidden lg:block absolute top-8 left-full w-8 hairline-gold" />
                                )}
                                <span className="font-display text-5xl sm:text-6xl text-gold/50 leading-none">
                                    {s.num}
                                </span>
                                <h3 className="font-accent text-sm uppercase tracking-[0.2em] text-ink mt-6">
                                    {s.title}
                                </h3>
                                <p className="font-body text-sm text-inksoft leading-relaxed mt-3">
                                    {s.desc}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.2} className="text-center mt-16">
                    <p className="font-display italic text-xl sm:text-2xl text-ink/70">
                        "Sua ideia, do seu jeito!"
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
